import { List } from 'immutable';

import { FILTERS } from 'src/components/Filters';
import FilterCityDistance from 'src/components/Filters/FilterCityDistance';
import FilterConfirmability from 'src/components/Filters/FilterConfirmability';

const {
  FilterPrices,
  FilterSuperCashback,
  FilterCancellationPolicy,
  FilterSpa,
  FilterFacilities,
  FilterFamilyWithKids,
  FilterRestrictions,
  FilterDirectFlight,
} = FILTERS;

const BOOLEAN_FILTERS = [
  FilterSuperCashback.filterName,
  FilterCancellationPolicy.filterName,
  ...FilterSpa.customFilters,
  ...FilterFacilities.customFilters,
  ...FilterFamilyWithKids.customFilters,
  ...FilterRestrictions.customFilters,
  ...FilterDirectFlight.customFilters,
];
// Below located same function but for plain JS objects
export const filterDataToURL = (filterName, filterData) => {
  if (filterName === FilterPrices.filterName) {
    return {
      filter_price_min: filterData.get('minPrice'),
      filter_price_max: filterData.get('maxPrice'),
    };
  }

  const filterParam = `filter_${filterName}`;

  // Для фильтра подтверждаемости не пишем в урл третью опцию
  // (при которой должны отображаться все отели)
  if (
    filterName === FilterConfirmability.filterName &&
    filterData.toJS().find((item) => item.id === 3 && item.selected)
  ) {
    return { [filterParam]: undefined };
  }

  if (BOOLEAN_FILTERS.indexOf(filterName) !== -1) {
    return { [filterParam]: filterData.getIn([0, 'selected']) };
  }

  if (List.isList(filterData)) {
    const paramValue = filterData
      .reduce((acc, item) => {
        const res = [...acc];

        if (item.get('selected')) {
          res.push(item.get('id'));
        }

        return res;
      }, [])
      .join(',');

    return { [filterParam]: paramValue };
  }

  if (filterName === FilterCityDistance.filterName) {
    const maxDistance = filterData.get('max_distance');
    const selectedMaxDistance = filterData.get('selected_max_distance');
    return {
      [filterParam]:
        selectedMaxDistance === maxDistance ? null : selectedMaxDistance,
    };
  }

  return { [filterParam]: filterData.get('value') };
};

export const clearFilter = (filterName, filterData) => {
  if (filterName === FilterPrices.filterName) {
    return {
      minPrice: null,
      maxPrice: null,
    };
  }

  if (List.isList(filterData)) {
    return filterData
      .map((filterItem) => ({
        id: filterItem.get('id'),
        selected: false,
      }))
      .toJS();
  }

  if (filterName === FilterCityDistance.filterName) {
    return {
      selected_max_distance: filterData.get('max_distance'),
    };
  }

  return { value: null };
};
